import { render, staticRenderFns } from "./media.vue?vue&type=template&id=cb2b10d6&"
import script from "./media.vue?vue&type=script&lang=ts&"
export * from "./media.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports